:host {
  contain: content;

  /* Ensure that we expand to the width of the widest child element in the set */
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;

  /* First item: curved top, straight bottom */
  ::slotted(:first-of-type) {
    border-top: 1px solid var(--theme-secondary-border);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    clip-path: inset(-8px -8px 0px -8px);
  }

  /* Middle items: straight edges all around */
  ::slotted(:not(:first-of-type):not(:last-of-type)) {
    border-top: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    clip-path: inset(0 -8px 0 -8px);
  }

  /* Last item: straight top, curved bottom */
  ::slotted(:last-of-type) {
    border-top: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom: 1px solid var(--theme-secondary-border);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    clip-path: inset(0 -8px -8px -8px);
  }

  /* Only item: curved all around (override other rules) */
  ::slotted(:only-of-type) {
    border-top: 1px solid var(--theme-secondary-border);
    border-bottom: 1px solid var(--theme-secondary-border);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    clip-path: unset;
  }
}
